import WiretapApp from 'bam-wiretap/WiretapApp';
import trackingJson from './configs/mig-uhg-tracking.json';

/**
 * Set the variables inside the tracking event object.
 * Should be overridden by the custom section implementations.
 * @param  {object} trackObj Config properties.
 * @param  {jquery} $el      The jquery event element.
 */
const setCustomTrackingVars = function (trackObj, $el) {
    const pageMeta = window.pageMeta;
    const { siteName, page_section, page_name, club, ['team-id']: teamId } = pageMeta;

    // Replace any variables within each prop value.
    $.each(trackObj, (prop, val) => {
        let value = val.toString();
        const gameInfo = $el.parents('.mlb-scores__list-item').find('.g5-component--mlb-scores__game-wrapper');

        if (value.indexOf('@') !== -1) {
            if (value.match(/@SITENAME@/)) {
                value = value.replace(/@SITENAME@/, siteName);
            }
            if (value.match(/@PAGESECTION@/)) {
                value = value.replace(/@PAGESECTION@/, page_section);
            }
            if (value.match(/@PAGENAME@/)) {
                value = value.replace(/@PAGENAME@/, page_name);
            }
            if (value.match(/@PLAYERID@/)) {
                value = value.replace(/@PLAYERID@/, $el.data('player-id'));
            }
            if (value.match(/@PLAYER@/)) {
                value = value.replace(/@PLAYER@/, $el.data('player'));
            }
            if (value.match(/@LINK@/)) {
                value = value.replace(/@LINK@/, $el.attr('href'));
            }
            if (value.match(/@LINKTEXT@/)) {
                value = value.replace(/@LINKTEXT@/, $el.find('.p-button__text').text().trim());
            }
            if (value.match(/@PROMOTEXT@/)) {
                value = value.replace(/@PROMOTEXT@/, $el.find('span').text().trim());
            }
            if (value.match(/@PLAYERINDEX@/)) {
                value = value.replace(/@PLAYERINDEX@/, $el.parents('.g5-component--mlb-scores__player').index());
            }
            if (value.match(/@PLINKINDEX@/)) {
                value = value.replace(/@PLINKINDEX@/, $el.parents().index());
            }
            if (value.match(/@STATUS@/)) {
                value = value.replace(/@STATUS@/, gameInfo.data('game-scenario'));
            }
            if (value.match(/@MIGGAMEDETAILS@/)) {
                const teamInfo = window.team_info;
                const awayTeam = teamInfo.find(team => team.id === gameInfo.data('game-away-id')).name;
                const homeTeam = teamInfo.find(team => team.id === gameInfo.data('game-home-id')).name;
                const gameDate = new Date(gameInfo.data('game-date').replace(/-/g, '/'));
                const gameDateFormat = gameDate.toDateString();
                const atVs = (gameInfo.data('game-home-id') === parseInt(teamId, 10)) ? 'vs' : '@';
                const gameDetails = `${homeTeam} ${atVs} ${awayTeam}: ${gameDateFormat}`;
                value = value.replace(/@MIGGAMEDETAILS@/, gameDetails);
            }
            if (value.match(/@UHGGAMEDETAILS@/)) {
                const awayTeam = $el.parents('.games-component').find('.p-upcoming-games--vs--teamName').text().trim().toUpperCase();
                const homeTeam = club && club.toUpperCase();
                const season = window.datesProperties.schedule.season;
                const dateInfo = $el.parents('.p-upcoming-games--games.games-container').find('.p-upcoming-games--games-date').remove('.games-date-divider').text();
                // Clean up extra spaces from the dom
                const gameDate = dateInfo.replace(/\s\s+/g, ' ').trim();
                const gameDateFormat = `${gameDate.substring(0, gameDate.length - 11)}${season}`;
                const gameDetails = `${homeTeam} vs ${awayTeam}: ${gameDateFormat}`;
                value = value.replace(/@@UHGGAMEDETAILS@/, gameDetails);
            }
            if (value.match(/@UHGPOSITION@/)) {
                const uhgPosition = $el.parents('.p-upcoming-games--games.games-container').index() + 1;
                value = value.replace(/@UHGPOSITION@/, uhgPosition);
            }

            trackObj[prop] = value;

        }

        // Remove any bad props.
        if (trackObj[prop] === 'undefined' || trackObj[prop] === null) {
            delete trackObj[prop];
        }
    });

    return trackObj;
};

export default new WiretapApp(trackingJson, setCustomTrackingVars, {});
